__turbopack_context__.v({
  "button": "styles-module-scss-module__K_GoZW__button",
});
